// Always-rendered error slot: reserves its height so an error appearing never shifts the layout.
// `floating` renders it as a dismissible bubble below the input (used inside slab/tier rows).
import React, { useState, useEffect } from 'react';
import { AlertCircle, X } from 'lucide-react';
import styles from './ShiftTypeModal.module.css';

const FieldError = ({ message, floating = false }) => {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => { setDismissed(false); }, [message]);

  const visible = !!message && !(floating && dismissed);

  return (
    <span className={`${styles.errorSlot} ${floating ? styles.floating : ''} ${visible ? styles.visible : ''}`} aria-live="polite">
      {visible && <AlertCircle size={12} style={{ flexShrink: 0, marginTop: '0.15rem' }} />}
      <span className={styles.errorMessage}>{visible ? message : ' '}</span>
      {visible && floating && (
        <button type="button" className={styles.errorClose} onClick={() => setDismissed(true)} title="Dismiss">
          <X size={12} />
        </button>
      )}
    </span>
  );
};

export default FieldError;
